import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Button } from './ui/button';
import CartDialog from './CartDialog';

const Header = () => {
  const location = useLocation();
  const { getCartCount } = useCart();
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Shop', path: '/shop' },
    { name: 'Reviews', path: '/reviews' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Track Order', path: '/track-order' },
    { name: 'Contact Us', path: '/contact' }
  ];

  return (
    <>
      <header className="sticky top-0 z-50 w-full bg-cream border-b border-brown-200" style={{ backgroundColor: '#f7f5f2' }}>
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex-shrink-0">
              <img 
                src="https://customer-assets.emergentagent.com/job_48fa2328-69a6-47d6-a09d-67288600a773/artifacts/di13voej_A14597EA-17F5-436E-B720-266D21072789.PNG" 
                alt="The Maple Daddies" 
                className="h-16 w-auto transition-transform hover:scale-105"
              />
            </Link>

            {/* Desktop Navigation - Centered */}
            <nav className="hidden md:flex items-center justify-center flex-1 mx-8">
              <ul className="flex items-center space-x-8">
                {navItems.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className={`text-base font-medium transition-colors hover:text-maple-orange ${
                        location.pathname === item.path
                          ? 'text-maple-orange border-b-2 border-maple-orange'
                          : 'text-brown-800'
                      }`}
                      style={{
                        color: location.pathname === item.path ? '#FF8C19' : '#4a2c1a'
                      }}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Cart Button */}
            <div className="flex items-center space-x-4">
              <Button
                variant="outline"
                size="icon"
                className="relative border-2 hover:bg-orange-50 transition-colors"
                style={{ borderColor: '#FF8C19' }}
                onClick={() => setIsCartOpen(true)}
              >
                <ShoppingCart className="h-5 w-5" style={{ color: '#FF8C19' }} />
                {getCartCount() > 0 && (
                  <span
                    className="absolute -top-2 -right-2 h-5 w-5 rounded-full text-white text-xs flex items-center justify-center font-bold"
                    style={{ backgroundColor: '#FF8C19' }}
                  >
                    {getCartCount()}
                  </span>
                )}
              </Button>

              {/* Mobile Menu Button */}
              <Button
                variant="outline"
                size="icon"
                className="md:hidden border-2"
                style={{ borderColor: '#FF8C19' }}
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              >
                {isMobileMenuOpen ? (
                  <X className="h-5 w-5" style={{ color: '#FF8C19' }} />
                ) : (
                  <Menu className="h-5 w-5" style={{ color: '#FF8C19' }} />
                )}
              </Button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMobileMenuOpen && (
            <nav className="md:hidden py-4 border-t" style={{ borderColor: '#e5d5c0' }}>
              <ul className="space-y-3">
                {navItems.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className={`block py-2 text-base font-medium transition-colors ${
                        location.pathname === item.path
                          ? 'text-maple-orange'
                          : 'text-brown-800 hover:text-maple-orange'
                      }`}
                      style={{
                        color: location.pathname === item.path ? '#FF8C19' : '#4a2c1a'
                      }}
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </div>
      </header>

      <CartDialog isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  );
};

export default Header;